import { FC, useCallback, useEffect, useState } from "react";
import {
  Button,
  Form,
  Radio,
  RadioChangeEvent,
  Typography,
  Tooltip,
  Checkbox,
} from "antd";
import { useForm } from "antd/es/form/Form";
import {
  CommentDrawerContentDecisionForm,
  FooterButtonRow,
  StyledTextArea,
} from "./styled";
import { ContentWrapper } from "../styled";
import {
  ECommentDecisionAction,
  EMemberRole,
  TCommentData,
  TCommentDecisionPayload,
  TResponsibleEngineer,
} from "../../../types";
import { FormTextWrapper } from "../..";
// import { getProjectEngineers, makeCommentDecision } from "services";

const decisionOptions = [
  {
    disabled: true,
    label: "Снять в рабочем порядке",
    value: ECommentDecisionAction.REMOVE_IN_WORKING_ORDER,
  },
  {
    label: "Передать для принятия решения",
    value: ECommentDecisionAction.TRANSFER_FOR_DECISION,
  },
  {
    label: "Отклонить",
    value: ECommentDecisionAction.REJECT,
  },
];

const votingRolesOptions = [
  {
    label: "ГИП заказчика",
    value: EMemberRole.CHIEF_PROJECT_ENGINEER,
  },
  {
    label: "ГИП проектного института",
    value: EMemberRole.CHIEF_PROJECT_ENGINEER_PI,
  },
];

interface ICommentDrawerContentDecisionProps {
  comment: TCommentData;
  onAfterSubmit: () => void;
  setStep: (value: number) => void;
}

export const CommentDrawerContentDecision: FC<
  ICommentDrawerContentDecisionProps
> = ({ comment, onAfterSubmit, setStep }) => {
  const [isLoading, setLoading] = useState(false);
  const [form] = useForm();
  const [decisionState, setDecisionState] = useState<string>(
    ECommentDecisionAction.TRANSFER_FOR_DECISION
  );
  const [projectResponsibleEngineers, setProjectResponsibleEngineers] =
    useState<TResponsibleEngineer[]>([]);

  const makeCommentsDecision = async (values: TCommentDecisionPayload) => {
    // setLoading(true);

    const response = true;
    // await makeCommentDecision(comment.id, values);

    // setLoading(false);

    if (response) {
      onAfterSubmit();
    }
  };

  const handleSubmit = () => {
    form
      .validateFields()
      .then((values) => makeCommentsDecision(values))
      .catch((info) => {
        console.error("Validate Failed:", info);
      });
  };

  const onChangeDecision = (e: RadioChangeEvent) => {
    setDecisionState(e.target.value);
  };

  const onChangeAgreedEngineers = (isCheck: boolean, value: number) => {
    if (isCheck) {
      form.setFieldsValue({
        ...form.getFieldsValue(),
        agreedEngineers: [...form.getFieldValue("agreedEngineers"), value],
      });
    }

    if (!isCheck) {
      form.setFieldsValue({
        ...form.getFieldsValue(),
        agreedEngineers: form
          .getFieldValue("agreedEngineers")
          .filter((el: number) => el !== value),
      });
    }
  };

  // useEffect(() => {
  //   (async () => {
  //     const response = await getProjectEngineers(comment.project.id);

  //     if (response) {
  //       setProjectResponsibleEngineers(response);
  //     }
  //   })();
  // }, []);

  const findEngineerByRole = useCallback(
    (role: EMemberRole) => {
      const engineer = projectResponsibleEngineers.find(
        (el) => el.position === role
      );

      if (engineer) {
        return engineer.fullName;
      }

      return "";
    },
    [projectResponsibleEngineers]
  );

  return (
    <CommentDrawerContentDecisionForm
      form={form}
      data-testid="comment-decision-form"
      name="comment-decision-form"
      initialValues={{
        decisionAction: ECommentDecisionAction.TRANSFER_FOR_DECISION,
        descriptionDecision: "",
        responsibleRole: EMemberRole.ARCHITECTURAL_SUPERVISION,
        agreedEngineers: [],
      }}
      onSubmitCapture={handleSubmit}
      validateMessages={{ default: "", required: "Обязательно для заполнения" }}
    >
      <div className="content-decision-wrapper">
        <ContentWrapper>
          <Typography.Title level={5}>Решение</Typography.Title>

          <Form.Item name="decisionAction" required>
            <Radio.Group
              options={decisionOptions}
              onChange={onChangeDecision}
            />
          </Form.Item>

          {decisionState === ECommentDecisionAction.REJECT && (
            <FormTextWrapper
              label="Причина отклонения"
              maxLength={512}
              name="descriptionDecision"
              required
            >
              <StyledTextArea placeholder="Например," rows={3} />
            </FormTextWrapper>
          )}

          {decisionState === ECommentDecisionAction.TRANSFER_FOR_DECISION && (
            <>
              <Form.Item
                className="voting-roles-wrapper"
                label="Выберите согласовантов:"
                name="agreedEngineers"
                rules={[
                  {
                    required: true,
                    transform: (value) => value.toString(),
                  },
                ]}
              >
                {votingRolesOptions.map((el) => (
                  <Checkbox
                    key={el.value}
                    onChange={(e: any) => onChangeAgreedEngineers(e, el.value)}
                    checked={(
                      form.getFieldValue("agreedEngineers") ?? []
                    ).includes(el.value)}
                  >
                    <Tooltip overlay={findEngineerByRole(el.value)}>
                      {el.label}
                    </Tooltip>
                  </Checkbox>
                ))}
              </Form.Item>

              <FormTextWrapper
                label="Описание решения"
                maxLength={512}
                name="descriptionDecision"
              >
                <StyledTextArea placeholder="Например," rows={3} />
              </FormTextWrapper>
            </>
          )}
        </ContentWrapper>

        <FooterButtonRow justify="space-between">
          <Button onClick={() => setStep(1)}>Назад</Button>

          <Button htmlType="submit" loading={isLoading} type="primary">
            Отправить
          </Button>
        </FooterButtonRow>
      </div>
    </CommentDrawerContentDecisionForm>
  );
};
